module.exports = __webpack_public_path__ + "static/side_farfale-3faea08d3de00c2f4002ecf4d72c6451.jpg";